<template>
  <div id="container">
    <van-swipe :autoplay="5000">
      <van-swipe-item v-for="(image, index) in model.photos" :key="index">
        <img :src="image.url" width="100%" />
      </van-swipe-item>
    </van-swipe>
    <div class="padding-10">
      <h2>{{model.name}}</h2>
    </div>
    <div class="block"/>
    <div class="padding-10">
      {{model.describe}}
    </div>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    Api.post('sal.product/model', {id: this.$route.query.id}, res => { this.model = res.data })
  },
  data () {
    return {
      model: {
        photos: []
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/sal/product/Model.vue